import _ from "underscore";

export function getCategoryList(state) {
    return state.ShoppingReducer.categories;
}

export function getProductList(state) {
    return state.ShoppingReducer.products;
}

export function getProductsList(state) {
    return state.ShoppingReducer.allProducts;
}

export function getProducts(state) {
    return state.ShoppingReducer.productList;
}

export function getCartList(state) {
    return state.ShoppingReducer.cart;
}

export function getBankAccounts(state) {
    return state.ShoppingReducer.bankAccounts;
}

export function getReviews(state) {
    return state.ShoppingReducer.shippingFees;
}

export function getCartProductList(state) {
    return state.ShoppingReducer.cartProducts;
}

export function getOrderList(state) {
    return _.sortBy(state.ShoppingReducer.orders, "code").reverse();
}

export function getOrderGroup(state) {
    return state.ShoppingReducer.orderGroup;
}

export function getUpgradePlan(state) {
    return state.ShoppingReducer.plans;
}

export function getPaymentConfig(state) {
    return state.ShoppingReducer.paymentConfig;
}

export function getPayoutConfig(state) {
    return state.ShoppingReducer.payoutConfig;
}

export function getOrderDetail(state) {
    return state.ShoppingReducer.orderDetail;
}

export function getInstantVideo(state) {
    return state.ShoppingReducer.instantVideo;
}

export function getInstantVideoProducts(state) {
    return state.ShoppingReducer.instantVideo.products;
}
